var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.open}},[_c('fa-icon',{style:({
      color: '#4d92e3',
      'font-size': '1.75em',
      margin: '3px 10px 0 0',
      cursor: 'pointer',
    }),attrs:{"icon":['fas', 'circle-question'],"size":"lg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }